import { useContext } from 'react';
import { WordsetContext } from '@/contexts/WordSetContext/entry';

export function useWordsetContext() {
  const {
    state,
    data,
    patientId,
    setId,
    editData,
    selectedWords,
    changeOuterState,
    changePage,
    changeLimitModal,
    changeBasicState,
    changePhenomenonState,
    changePhenomenonRowState,
    changeAllPhenomenonState,
    changeSelectedData,
    refetchWords,
    limitModal,
    tags,
    toggleRefreshWordSetTrue,
    refreshWordsSet,
    scrollViewRef,
    template,
  } = useContext(WordsetContext);

  return {
    term: state.term,
    termType: state.termType,
    basic: state.basic,
    phonemes: state.phonemes,
    searchType: state.searchType,
    searchWordsPerPage: state.searchWordsPerPage,
    page: state.page,
    partsOfSpeech: state.partsOfSpeech,
    limitModal,
    patientId,
    setId,
    editData,
    data,
    selectedWords,
    changeOuterState,
    changePage,
    changeLimitModal,
    changeBasicState,
    changePhenomenonState,
    changePhenomenonRowState,
    changeAllPhenomenonState,
    changeSelectedData,
    refetchWords,
    dataKeyName: 'words',
    apiKeyName: 'wordsets',
    dynamicName: 'wordset',
    tags,
    toggleRefreshWordSetTrue,
    refreshWordsSet,
    template,
    scrollViewRef,
  };
}
